import { render } from "./ManageAssigneesDialog.vue?vue&type=template&id=0d03d68c&scoped=true"
import script from "./ManageAssigneesDialog.vue?vue&type=script&lang=js"
export * from "./ManageAssigneesDialog.vue?vue&type=script&lang=js"

import "./ManageAssigneesDialog.vue?vue&type=style&index=0&id=0d03d68c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d03d68c"]])

export default __exports__